(function () {
  const context = window.WONTrackingContext || {};
  const seenEvents = new Set();

  function pushTrackingEvent(eventName, payload = {}) {
    const detail = {
      event: eventName,
      page_type: context.pageType || '',
      template: context.template || '',
      collection_handle: context.collectionHandle || '',
      product_handle: context.productHandle || '',
      product_id: context.productId || '',
      ...payload,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('won:tracking', { detail }));
  }

  function trackOnce(key, eventName, payload = {}) {
    if (seenEvents.has(key)) return;
    seenEvents.add(key);
    pushTrackingEvent(eventName, payload);
  }

  function normalizePath(value) {
    if (!value) return '';
    try {
      return new URL(value, window.location.origin).pathname;
    } catch (error) {
      return value;
    }
  }

  document.addEventListener('click', function (event) {
    const target = event.target.closest('a, button');
    if (!target) return;

    const href = target.getAttribute('href') || '';
    const path = normalizePath(href);
    const text = (target.textContent || '').trim();

    if (context.pageType === 'index') {
      if (target.closest('slideshow-component') && path === '/collections/rentals') {
        pushTrackingEvent('won_home_hero_cta_click', {
          cta_label: text || 'Shop Rentals',
          cta_target: path,
        });
      }

      if (
        target.closest('.shopify-section') &&
        target.classList.contains('button') &&
        path === '/collections/rentals' &&
        target.closest('[style*="justify-content: center"]')
      ) {
        pushTrackingEvent('won_home_primary_cta_click', {
          cta_label: text || 'Shop Rentals',
          cta_target: path,
        });
      }

      if (path === '#check-rental-availability' || href === '#check-rental-availability') {
        pushTrackingEvent('won_home_date_check_cta_click', {
          cta_label: text || 'Check Your Date',
          cta_target: '#check-rental-availability',
        });
      }

      if (target.closest('.availability-widget-shell') && target.classList.contains('search-button')) {
        pushTrackingEvent('won_home_date_checker_submit_click', {
          cta_label: text || 'Check availability',
        });
      }
    }

    if (
      (context.collectionHandle === 'rentals' || context.collectionHandle === 'all-rentals') &&
      target.closest('.collection-card-wrapper')
    ) {
      pushTrackingEvent('won_rental_hub_category_click', {
        category_label: text,
        category_target: path,
      });
    }

    if (
      (context.collectionHandle === 'all-purchase' || context.collectionHandle === 'purchase') &&
      target.closest('.collection-card-wrapper')
    ) {
      pushTrackingEvent('won_purchase_hub_category_click', {
        category_label: text,
        category_target: path,
      });
    }

    if (target.matches('.cart__checkout-button, [name="checkout"]')) {
      pushTrackingEvent('won_cart_checkout_click', {
        cta_label: text || 'Checkout',
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const availabilityShell = document.querySelector('.availability-widget-shell');
    if (availabilityShell) {
      const observer = new MutationObserver(function () {
        if (availabilityShell.dataset.widgetState === 'loaded') {
          trackOnce('availability_widget_loaded', 'won_home_date_checker_loaded');
        }

        if (availabilityShell.dataset.widgetState === 'fallback') {
          trackOnce('availability_widget_fallback', 'won_home_date_checker_fallback');
        }
      });

      observer.observe(availabilityShell, {
        attributes: true,
        attributeFilter: ['data-widget-state'],
      });

      if (availabilityShell.dataset.widgetState === 'loaded') {
        trackOnce('availability_widget_loaded', 'won_home_date_checker_loaded');
      }
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (eventData) {
      pushTrackingEvent('won_add_to_cart_success', {
        source: eventData.source || '',
        variant_id: eventData.productVariantId || '',
      });
    });
  }
})();
